import Vue from "vue";
import Router from "vue-router";

import Associate from "@/components/associate/Associate.vue";
import ConnectionHistory from "@/components/connection-history/ConnectionHistory.vue";
import Connection from "@/components/connection/Connection.vue";
import Connections from "@/components/connection/Connections.vue";
import Devices from "@/components/device/Devices.vue";
import NoAccess from "@/components/errors/NoAccess.vue";
import NotFound from "@/components/errors/NotFound.vue";
import Unauthorized from "@/components/errors/Unauthorized.vue";
import Events from "@/components/events/Events.vue";
import Info from "@/components/info/Info.vue";
import CreateLocation from "@/components/location/CreateLocation.vue";
import EditLocation from "@/components/location/EditLocation.vue";
import Locations from "@/components/location/Locations.vue";
import Settings from "@/components/settings/Settings.vue";
import About from "@/components/about/About.vue";
import SignIn from "@/components/SignIn.vue";
import { requireAuth } from "@/utils/auth";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      // If a user is already logged in, the Sign In page will redirect them to their "home" page
      path: "/",
      redirect: "/sign-in"
    },
    {
      path: "/sign-in",
      name: "Sign In",
      props: true,
      component: SignIn
    },
    {
      path: "/info",
      name: "Info",
      beforeEnter: requireAuth("get:info"),
      component: Info
    },
    {
      path: "/associate",
      name: "Associate",
      beforeEnter: requireAuth("get:device", "get:patient", "get:settings", "action:associate", "action:manualEntry"),
      component: Associate
    },
    {
      path: "/connections",
      name: "Connections",
      beforeEnter: requireAuth("get:connections"),
      component: Connections
    },
    {
      path: "/connections/:serial",
      name: "Connection",
      beforeEnter: requireAuth("get:connection"),
      component: Connection
    },
    {
      path: "/devices",
      name: "Devices",
      beforeEnter: requireAuth("get:devices"),
      component: Devices
    },
    {
      // Put connection history on the devices page because admins and service accounts have access to the devices page
      // whereas only service accounts have access to the connections page
      path: "/devices/history",
      name: "Connection History",
      beforeEnter: requireAuth("get:devices"),
      component: ConnectionHistory
    },
    {
      path: "/events",
      name: "Events",
      beforeEnter: requireAuth("get:events"),
      component: Events
    },
    {
      path: "/locations",
      name: "Locations",
      beforeEnter: requireAuth("get:locations"),
      component: Locations
    },
    {
      path: "/locations/create",
      name: "CreateLocation",
      beforeEnter: requireAuth("create:location"),
      component: CreateLocation
    },
    {
      path: "/locations/:ip",
      name: "EditLocation",
      beforeEnter: requireAuth("update:location"),
      component: EditLocation
    },
    {
      path: "/settings",
      name: "Settings",
      beforeEnter: requireAuth("get:settings", "update:settings"),
      component: Settings
    },
    {
      path: "/about",
      name: "About",
      component: About
    },

    {
      path: "/no-access",
      name: "No Access",
      beforeEnter: requireAuth(),
      component: NoAccess
    },
    {
      path: "/unauthorized",
      name: "Unauthorized",
      component: Unauthorized
    },

    // FYI this route must be last in order to catch any unmatched requests
    {
      path: "*",
      name: "NotFound",
      component: NotFound
    }
  ]
});
